/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The UsersLoginBody model module.
 * @module model/UsersLoginBody
 * @version 1.0.0
 */
export class UsersLoginBody {
  /**
   * Constructs a new <code>UsersLoginBody</code>.
   * @alias module:model/UsersLoginBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>UsersLoginBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/UsersLoginBody} obj Optional instance to populate.
   * @return {module:model/UsersLoginBody} The populated <code>UsersLoginBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new UsersLoginBody();
      if (data.hasOwnProperty('username'))
        obj.username = ApiClient.convertToType(data['username'], 'String');
      if (data.hasOwnProperty('password'))
        obj.password = ApiClient.convertToType(data['password'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} username
 */
UsersLoginBody.prototype.username = undefined;

/**
 * @member {String} password
 */
UsersLoginBody.prototype.password = undefined;

